import React, { useState } from 'react';
import './LanguageSelector.css';

import i18n from '../i18n.js';

import UKFlag from './flags/UKFlag.png';
import USAFlag from './flags/USAFlag.png';
import CanadaFlag from './flags/CanadaFlag.png';
import AustraliaFlag from './flags/AustraliaFlag.png';
import EspagnolFlag from './flags/EspagnolFlag.png';
import FrenchFlag from './flags/FrenchFlag.png';
import GermanyFlag from './flags/GermanyFlag.png';
import IndiaFlag from './flags/IndiaFlag.png';
import ItaliaFlag from './flags/ItaliaFlag.png';
import JaponFlag from './flags/JaponFlag.png';
import MandarinChineseFlag from './flags/MandarinChineseFlag.png';
import PortugalFlag from './flags/PortugalFlag.png';
import RussiaFlag from './flags/RussiaFlag.png';
import SaudiArabiaFlag from './flags/SaudiArabiaFlag.png';

const languages = [
  { code: 'en', name: 'English (USA)', flag: USAFlag },
  { code: 'en', name: 'English (UK)', flag: UKFlag },
  { code: 'en', name: 'English (Canada)', flag: CanadaFlag },
  { code: 'en', name: 'English (Australia)', flag: AustraliaFlag },
  { code: 'es', name: 'Spanish', flag: EspagnolFlag },
  { code: 'fr', name: 'French', flag: FrenchFlag },
  { code: 'de', name: 'German', flag: GermanyFlag },
  { code: 'hi', name: 'Hindi', flag: IndiaFlag },
  { code: 'ita', name: 'Italian', flag: ItaliaFlag },
  { code: 'ja', name: 'Japanese', flag: JaponFlag },
  { code: 'zh', name: 'Mandarin', flag: MandarinChineseFlag },
  { code: 'pt', name: 'Portuguese', flag: PortugalFlag },
  { code: 'ru', name: 'Russian', flag: RussiaFlag },
  { code: 'ara', name: 'Arabic', flag: SaudiArabiaFlag },
];

export default function LanguageSelector({ currentLanguage, onChangeLanguage }) {
  const [open, setOpen] = useState(false);

  const handleSelect = async (lang) => {
    setOpen(false);
    try {
      const langCode = lang.code;
      localStorage.setItem('language', langCode);
      await i18n.changeLanguage(langCode);
      if (onChangeLanguage) onChangeLanguage(langCode);
    } catch (error) {
      console.error('Error changing language:', error);
    }
  };

  const currentLang = languages.find(l => l.code === currentLanguage) || languages[0];

  return (
    <div className="language-selector">
      <button className="lang-btn" onClick={() => setOpen(!open)}>
        <img src={currentLang.flag} alt={currentLang.name} className="lang-flag" />
      </button>
      {open && (
        <ul className="lang-dropdown">
          {languages.map((lang, index) => (
            <li
              key={lang.code + '-' + index}
              onClick={() => handleSelect(lang)}
              className={`lang-option ${lang.code === currentLanguage ? 'selected' : ''}`}
            >
              <img src={lang.flag} alt={lang.name} className="lang-flag" />
              <span>{lang.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
